export function parseIsWingHead(value) {
    return value === true || value === "true" || value === 1 || value === "1";
}

export function saveWingHeadStatus(data) {
    const isWingHead = parseIsWingHead(data?.IsWingHead);
    localStorage.setItem("IsWingHead", isWingHead ? "true" : "false");
    localStorage.setItem("WingHeadWingIds", data?.WingHeadWingIds || "");
    localStorage.setItem("WingHeadWingNames", data?.WingHeadWingNames || "");
    window.dispatchEvent(new Event("wingHeadStatusUpdated"));
    return isWingHead;
}

export function readIsWingHeadFromStorage() {
    return localStorage.getItem("IsWingHead") === "true";
}
